import PropTypes from 'prop-types'
import ProductListSkeleton from 'components/product/product-list-skeleton'

const RelatedProductSectionSkeleton = ({ customStyles, number, withCTA }) => (
  <ProductListSkeleton
    number={number}
    withCTA={withCTA}
    withTitle
    customStyles={customStyles}
  />
)

RelatedProductSectionSkeleton.defaultProps = {
  customStyles: { padding: '50px 0 30px' },
  number: 8,
  withCTA: false,
}

RelatedProductSectionSkeleton.propTypes = {
  customStyles: PropTypes.shape({}),
  number: PropTypes.number,
  withCTA: PropTypes.bool,
}

export default RelatedProductSectionSkeleton
